import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";

import Tooltip from "features/components/Tooltip";
import DuckLoadingSpinnerIcon from "features/ui/Icons/DuckLoadingSpinnerIcon";

export enum SubthreadStatus {
  STREAMING = "STREAMING",
  PARTIALLY_COMPLETED = "PARTIALLY_COMPLETED",
  COMPLETED = "COMPLETED",
}

interface SubthreadStatusIndicatorProps {
  status: SubthreadStatus;
  title?: string;
}

const SubthreadStatusIndicator = ({
  status,
  title,
}: SubthreadStatusIndicatorProps) => (
  <Tooltip title={title}>
    {status === SubthreadStatus.STREAMING ? (
      <span className="animate-spin">
        <DuckLoadingSpinnerIcon size={12} />
      </span>
    ) : status === SubthreadStatus.COMPLETED ? (
      <CheckCircleOutlinedIcon
        fontSize="inherit"
        color="success"
        data-testid="completed-icon"
      />
    ) : status === SubthreadStatus.PARTIALLY_COMPLETED ? (
      <span
        className="block w-2.5 h-2.5 rounded-full"
        style={{
          background:
            "conic-gradient(var(--color-slate-400) 0deg 180deg, var(--color-green-400) 180deg 360deg)",
        }}
      />
    ) : (
      <span className="animate-spin">
        <DuckLoadingSpinnerIcon size={12} />
      </span>
    )}
  </Tooltip>
);

export default SubthreadStatusIndicator;
